var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHeadphones3 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 252.96 264.98",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222,44.86C198.78,16.77,162.89,0,126,0l-.66,0C76.94,2.58,41.83,19.24,21,49.52-13,98.87,3.38,167.4,8,183.76a25.77,25.77,0,0,0-4.56,14.7c.13,12.61,2.35,39.77,18.35,57.54,15,16.68,45,5,45,5S93.5,266,93.5,248.5,71,147.6,51.81,150.1c-13.34,1.74-16.68,14.18-16.68,14.18a59.12,59.12,0,0,0-5.57,2.34c-4.83-22.5-10.95-69.51,12-102.92C57.76,40.22,86.27,27.2,126.35,25c29.39.09,57.93,13.46,76.4,35.79,21.12,25.52,29.06,62,23.33,105.93-3.43-1.63-5.83-2.46-5.83-2.46s-3.34-12.44-16.68-14.18c-19.17-2.5-41.69,80.89-41.69,98.4S188.56,261,188.56,261s30,11.67,45-5c16-17.77,18.22-44.93,18.35-57.54a25.24,25.24,0,0,0-3.51-13C262.28,112.4,241.73,68.67,222,44.86Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeadphones3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/headphones_3.da6bf8ef.svg";
export { ForwardRef as ReactComponent };